import { render, staticRenderFns } from "./7.vue?vue&type=template&id=fa589ae0&scoped=true&"
var script = {}
import style0 from "./7.vue?vue&type=style&index=0&id=fa589ae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa589ae0",
  null
  
)

export default component.exports